import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import mangoCartons from "../assets/announcements/mango-cartons.webp";

export default function AnnouncementPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show popup only once per session
    const seen = sessionStorage.getItem("announcement_seen");
    if (!seen) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    sessionStorage.setItem("announcement_seen", "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Backdrop */}
          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm"
            onClick={close}
          />

          {/* Modal */}
          <motion.div
            key="popup"
            initial={{ opacity: 0, scale: 0.92, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-0 z-[101] flex items-center justify-center p-4 pointer-events-none"
          >
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden pointer-events-auto">

              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={mangoCartons}
                  alt="Mango Gift Boxes"
                  className="w-full h-full object-cover"
                  loading="eager"
/>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

                {/* Close button */}
                <button
                  onClick={close}
                  className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/30 backdrop-blur-sm text-white hover:bg-black/50 transition flex items-center justify-center"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                {/* Label over image */}
                <div className="absolute bottom-3 left-4">
                  <span className="bg-brand-green/90 text-white text-[10px] uppercase tracking-widest font-semibold px-3 py-1 rounded-full">
                    🥭 Season Special
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h2 className="font-heading text-xl font-bold text-gray-900 mb-3 leading-snug">
                  Premium Mango Gift Boxes for Your Valued Recipients
                </h2>

                <div className="space-y-2.5 text-sm text-gray-600 leading-relaxed mb-5">
                  <p>
                    PMS Packages is pleased to offer <strong>Premium Gift Boxes</strong> for valued customers,
                    employees, and other recipients this season.
                  </p>

                  <div className="flex flex-wrap gap-2 my-3">
                    <span className="bg-brand-green/10 text-brand-green text-xs font-semibold px-3 py-1.5 rounded-full">
                      📦 5–6 Kg Size
                    </span>
                    <span className="bg-brand-green/10 text-brand-green text-xs font-semibold px-3 py-1.5 rounded-full">
                      📦 7–8 Kg Size
                    </span>
                    <span className="bg-amber-50 text-amber-700 text-xs font-semibold px-3 py-1.5 rounded-full">
                      📍 Karachi Only
                    </span>
                  </div>

                  <p className="text-xs text-gray-400 italic">
                    As manufacturers of customised corrugated, die-cut, and RSC boxes — we guarantee top-notch quality at the best prices.
                  </p>
                </div>

                {/* Divider */}
                <div className="border-t border-gray-100 pt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-gray-400 font-semibold mb-0.5">Contact for Orders</p>
                    <a
                      href="mailto:packages.sales@pmsgroup.org"
                      className="text-sm font-semibold text-brand-green hover:underline"
                    >
                      packages.sales@pmsgroup.org
                    </a>
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={close}
                      className="px-4 py-2 text-xs text-gray-400 hover:text-gray-600 transition"
                    >
                      Dismiss
                    </button>
                    <a
                      href="mailto:packages.sales@pmsgroup.org"
                      onClick={close}
                      className="px-5 py-2 bg-brand-green text-white text-xs uppercase tracking-widest font-semibold rounded-lg hover:bg-brand-blue transition-colors duration-200"
                    >
                      Get a Quote
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}